var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiesel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 0.5H1.33301C0.781508 0.5 0.333008 0.9485 0.333008 1.5V14.5C0.333008 15.0515 0.781508 15.5 1.33301 15.5H9.33301C9.88451 15.5 10.333 15.0515 10.333 14.5V1.5C10.333 0.9485 9.88451 0.5 9.33301 0.5ZM8.33301 5.5C8.33301 6.0515 7.88451 6.5 7.33301 6.5H3.33301C2.78151 6.5 2.33301 6.0515 2.33301 5.5V3.5C2.33301 2.9485 2.78151 2.5 3.33301 2.5H7.33301C7.88451 2.5 8.33301 2.9485 8.33301 3.5V5.5Z",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 6.5H9.83301C9.55701 6.5 9.33301 6.276 9.33301 6C9.33301 5.724 9.55701 5.5 9.83301 5.5H11.833C12.109 5.5 12.333 5.724 12.333 6C12.333 6.276 12.109 6.5 11.833 6.5Z",
    fill: "#101010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 14.5C11.557 14.5 11.333 14.276 11.333 14V6C11.333 5.724 11.557 5.5 11.833 5.5C12.109 5.5 12.333 5.724 12.333 6V14C12.333 14.276 12.109 14.5 11.833 14.5Z",
    fill: "#101010"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.833 14.5H11.833C11.557 14.5 11.333 14.276 11.333 14C11.333 13.724 11.557 13.5 11.833 13.5H13.833C14.109 13.5 14.333 13.724 14.333 14C14.333 14.276 14.109 14.5 13.833 14.5Z",
    fill: "#101010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2946 2.80912C14.2691 2.74812 14.2326 2.69263 14.1866 2.64663L12.1866 0.646625C11.9911 0.451125 11.6751 0.451125 11.4796 0.646625C11.2841 0.842125 11.2841 1.15812 11.4796 1.35362L11.8266 1.70063C11.5161 2.06163 11.3331 2.51862 11.3331 3.00012C11.3331 4.10312 12.2301 5.00012 13.3331 5.00012V14.0001C13.3331 14.2761 13.5571 14.5001 13.8331 14.5001C14.1091 14.5001 14.3331 14.2761 14.3331 14.0001V3.00012C14.3331 2.93512 14.3196 2.87012 14.2946 2.80912Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiesel);
export default __webpack_public_path__ + "static/media/diesel.d1b3c80209a73fba23f0dbbeb8201597.svg";
export { ForwardRef as ReactComponent };